import { useEffect, useRef, useState } from 'react'
import MateriaCard from './MateriaCard.jsx'
import { Button, Chip, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Switch, Tab, Tabs, useDisclosure } from '@heroui/react'
import DetalleMateriaModal from './modals/DetalleMateriaModal.jsx'
import ConfirmarCambioModal from './modals/ConfirmarCambioModal.jsx'
import CapturaTransicionModal from './modals/CapturaTransicionModal.jsx'
import { useNavigate } from 'react-router-dom'
import materiasUtils from '../../utils/Progreso/materiasUtils.js'
import useProgresoMaterias from '../../hooks/Progreso/useProgresoMaterias.jsx'
import { useAuth } from '../../context/AuthContext.jsx'
import regularidadUtils from '../../utils/Progreso/regularidadUtils.js'

function MateriasList({ progreso, setProgreso, progresoDetalles, setProgresoDetalles, materias, isProgressSticky, plan }) {
    const { updateAuthProgreso } = useAuth();
    const [infoMateria, setInfoMateria] = useState()
    const { cambioDeEstado } = useProgresoMaterias(progreso, setProgreso, materias, plan, updateAuthProgreso)
    
    // Efecto para verificar vencimientos pasivos al cargar
    useEffect(() => {
        if (!progreso || !progresoDetalles) return;
        
        let huboCambios = false;
        const nuevoProgreso = { ...progreso };
        
        Object.entries(progreso).forEach(([codigo, estado]) => {
            if (estado === 'Regular') {
                const detalles = progresoDetalles[codigo];
                if (detalles?.fechaRegularidad) {
                    const estadoActualizado = regularidadUtils.calcularEstadoConsolidado(
                        "Regular",
                        detalles.fechaRegularidad,
                        detalles.intentosFinal
                    );
                    if (estadoActualizado === 'Libre') {
                        nuevoProgreso[codigo] = 'Libre';
                        huboCambios = true;
                    }
                }
            }
        });
        
        if (huboCambios) {
            setProgreso(nuevoProgreso);
            updateAuthProgreso(plan, nuevoProgreso, progresoDetalles);
        }
    }, []);
    const [confirmacion, setConfirmacion] = useState(false)
    const [mostrar, setMostrar] = useState(true)
    //Logica para mostrar u ocultar las materias de un año
    const [isAnioOpen, setIsAnioOpen] = useState(() => {
        const guardado = localStorage.getItem('materias_isAnioOpen');
        if (guardado) {
            try { return JSON.parse(guardado); } catch (e) { return []; }
        }
        return [];
    });

    const [vista, setVista] = useState(() => localStorage.getItem('materias_vista_preferida') || 'grid');

    useEffect(() => {
        localStorage.setItem('materias_vista_preferida', vista);
    }, [vista]);

    useEffect(() => {
        localStorage.setItem('materias_isAnioOpen', JSON.stringify(isAnioOpen));
    }, [isAnioOpen]);
    const navigate = useNavigate()

    // Para el Drawer/Info de la materia
    const {
        isOpen: isDetailOpen,
        onOpen: onDetailOpen,
        onClose: onDetailClose,
        onOpenChange: onDetailOpenChange
    } = useDisclosure()

    // Para el Modal de confirmación de borrado
    const {
        isOpen: isResetOpen,
        onOpen: onResetOpen,
        onOpenChange: onResetOpenChange,
        onClose: onResetClose
    } = useDisclosure()

    //Para el modal de Confirmar regular una materia bloqueada
    const {
        isOpen: isConfirmationOpen,
        onOpen: onConfirmationOpen,
        onOpenChange: onConfirmationOpenChange,
        onClose: onConfirmationClose
    } = useDisclosure()

    // Para el modal de captura de datos por transición de estado
    const {
        isOpen: isCapturaOpen,
        onOpen: onCapturaOpen,
        onOpenChange: onCapturaOpenChange,
        onClose: onCapturaClose
    } = useDisclosure()
    const [capturaConfig, setCapturaConfig] = useState({ tipo: null, materia: null, pendingState: null })

    //Abrir la info de una materia con Drawer de HeroUI
    const abrirInfo = (materia) => {
        setInfoMateria(materia)
        onDetailOpen()

        window.history.pushState({ modalOpen: true }, "")
    }
    //Manejo el evento de que en celu haga para atrás, que cierre el modal y no se saque la página
    useEffect(() => {
        const handlePopState = () => onDetailClose()
        if (isDetailOpen) window.addEventListener("popstate", handlePopState)
        return () => window.removeEventListener("popstate", handlePopState)
    }, [isDetailOpen, onDetailClose])

    // Manejo de historial para modal de reset
    useEffect(() => {
        const handlePopState = () => onResetClose()
        if (isResetOpen) window.addEventListener("popstate", handlePopState)
        return () => window.removeEventListener("popstate", handlePopState)
    }, [isResetOpen, onResetClose])

    // Manejo de historial para modal de confirmación
    useEffect(() => {
        const handlePopState = () => onConfirmationClose()
        if (isConfirmationOpen) window.addEventListener("popstate", handlePopState)
        return () => window.removeEventListener("popstate", handlePopState)
    }, [isConfirmationOpen, onConfirmationClose])

    //Para cambiar el tamaño de la barra de progreso
    const getProgressBar = () => {
        const sizeProgressBar = window.innerWidth
        if (sizeProgressBar < 640) { return "sm" }
        else if (sizeProgressBar < 768) { return "md" }
        else if (sizeProgressBar < 1024) { return "lg" }
    }
    const currentSize = getProgressBar()

    //Ordeno las materias dentro del array cuatrimestres, para poder mostrarlas en orden y separarlas por cuatrimestre
    const anios = [...new Set(materias.map((m) => Number(m.anio)))].sort((a, b) => a - b)
    const talleres = materias.filter(m => m.taller === true)
    // Para poder filtrar las materias
    const tabs = [
        {
            id: "todas",
            label: "Todas",
            content: anios
        },
        ...(talleres.length > 0 ? [{
            id: "talleres",
            label: "Talleres",
            content: ["taller"]
        }] : []),
        ...anios.map(anio => ({
            id: anio.toString(),
            label: `${anio}° Año`,
            content: [anio]
        }))
    ]

    //Para poder reestablecer el progreso
    const reestablecerProgreso = () => {
        const progresoInicial = {}

        // Usamos la lista de materias que ya tenemos en el estado
        materias.forEach(m => {
            if (m.tesis) {
                progresoInicial[m.codigo] = materiasUtils.bloquear
            } else {
                progresoInicial[m.codigo] = (m.correlativas.length > 0 ? materiasUtils.bloquear : materiasUtils.estadosPosibles[0])
            }
        })

        updateAuthProgreso(plan, progresoInicial, {});
        // Actualizo el progreso
        setProgreso(progresoInicial)
        if (setProgresoDetalles) setProgresoDetalles({})
        onResetClose()
    }
    //Abrir el modal de confirmar el reestablecer progreso
    const handleBorrado = () => {
        onResetOpen()
        window.history.pushState({ modalOpen: true }, "")
    }

    //Manejar el cambio de estado con Popover Menu
    const [codigoMateria, setCodigoMateria] = useState()
    const [targetStateModal, setTargetStateModal] = useState(null)

    const handleCambioDeEstado = (codigo, targetState) => {
        const mappedState = targetState === "Promocionado" ? "Aprobado" : targetState;
        const materia = materias.find(m => m.codigo === codigo);
        const estadoActual = progreso[codigo];

        if (mappedState === "Reiniciar") {
            const baseState = materia?.correlativas?.length > 0 ? materiasUtils.bloquear : materiasUtils.estadosPosibles[0];
            cambioDeEstado(codigo, baseState);
            return;
        }

        // Determinar tipo de captura según la transición
        let tipoCaptura = null;

        if (mappedState === "Cursando") {
            tipoCaptura = 'hacia_cursando';
        } else if (mappedState === "Regular") {
            tipoCaptura = estadoActual === 'Cursando' ? 'desde_cursando_hacia_reg' : 'hacia_regular';
        } else if (mappedState === "Aprobado") {
            if (estadoActual === 'Regular' || estadoActual === 'Cursando') {
                tipoCaptura = 'hacia_aprobado_desde_reg';
            } else {
                tipoCaptura = 'hacia_aprobado_directo';
            }
        }

        if (tipoCaptura) {
            setCapturaConfig({ tipo: tipoCaptura, materia, pendingState: mappedState });
            setCodigoMateria(codigo);
            onCapturaOpen();
            return;
        }

        // Estados sin formulario (Libre directo, etc.)
        cambioDeEstado(codigo, mappedState);
    }

    const handleCapturaConfirm = (payload) => {
        // _sugerirLibre: el usuario eligio "Marcar como Libre" desde la alerta de nota reprobatoria
        if (payload?._sugerirLibre) {
            if (codigoMateria) {
                const detallesActuales = progresoDetalles?.[codigoMateria] || {};
                const updatedDetalles = {
                    ...progresoDetalles,
                    [codigoMateria]: { ...detallesActuales, notaRegularizacion: payload.notaRegularizacion }
                };
                if (setProgresoDetalles) setProgresoDetalles(updatedDetalles);
                updateAuthProgreso(plan, progreso, updatedDetalles);
            }
            onCapturaClose();
            cambioDeEstado(codigoMateria, 'Libre');
            return;
        }

        if (payload && codigoMateria) {
            const detallesActuales = progresoDetalles?.[codigoMateria] || {};
            const estadoActual = progreso[codigoMateria];
            
            // ¿Es una recursada? (viniendo de Libre o Aprobado y queriendo regularizar/cursar de nuevo)
            const viniendoDeEstadoFinal = ['Libre', 'Aprobado'].includes(estadoActual);
            const yendoAEstadoActivo = ['Cursando', 'Regular', 'Aprobado'].includes(capturaConfig.pendingState);
            const esRecursada = viniendoDeEstadoFinal && yendoAEstadoActivo;

            let nuevosDetallesBase = { ...detallesActuales };

            if (esRecursada) {
                // Archivar la cursada actual en el historial
                const { historial, ...datosAArchivar } = detallesActuales;
                
                // Solo archivar si realmente hay algo significativo (intentos o fecha de regularidad)
                if ((datosAArchivar.intentosFinal && datosAArchivar.intentosFinal.length > 0) || datosAArchivar.fechaRegularidad) {
                    nuevosDetallesBase = {
                        historial: [
                            ...(historial || []),
                            { 
                                ...datosAArchivar, 
                                estadoFinal: estadoActual, // Guardamos que terminó como Libre o Aprobado
                                fechaFin: new Date().toISOString()
                            }
                        ],
                        // Limpiamos los datos actuales para la nueva cursada
                        intentosFinal: [],
                        fechaRegularidad: null,
                        notaRegularizacion: null,
                        fechaInicioCursada: null,
                        notaFinal: null
                    };
                }
            }

            const nuevosDetalles = {
                ...nuevosDetallesBase,
                ...(payload.fechaRegularidad !== undefined && { fechaRegularidad: payload.fechaRegularidad }),
                ...(payload.fechaInicioCursada !== undefined && { fechaInicioCursada: payload.fechaInicioCursada }),
                ...(payload.notaFinal !== undefined && { notaFinal: payload.notaFinal }),
                ...(payload.notaRegularizacion !== undefined && { notaRegularizacion: payload.notaRegularizacion }),
            };

            // Si transición 'desde_cursando_hacia_reg', copiar fechaInicioCursada como fechaRegularidad si no la tiene
            if (capturaConfig.tipo === 'desde_cursando_hacia_reg' && !nuevosDetalles.fechaRegularidad && nuevosDetallesBase.fechaInicioCursada) {
                nuevosDetalles.fechaRegularidad = nuevosDetallesBase.fechaInicioCursada;
            }

            if (payload.notaFinal != null && capturaConfig.pendingState === 'Aprobado') {
                const nuevoIntento = {
                    nota: payload.notaFinal,
                    estado: payload.notaFinal >= 4 ? 'aprobado' : 'reprobado',
                    fecha: new Date().toISOString()
                };
                nuevosDetalles.intentosFinal = [
                    ...(nuevosDetallesBase.intentosFinal || []),
                    nuevoIntento
                ];
            }

            const updatedDetalles = { ...progresoDetalles, [codigoMateria]: nuevosDetalles };
            if (setProgresoDetalles) setProgresoDetalles(updatedDetalles);
            updateAuthProgreso(plan, progreso, updatedDetalles);
        }

        onCapturaClose();
        // Aplicar el cambio de estado siempre
        if (capturaConfig.pendingState) {
            cambioDeEstado(codigoMateria, capturaConfig.pendingState);
        }
    }

    useEffect(() => {
        if (confirmacion === true) {
            cambioDeEstado(codigoMateria, targetStateModal)
            setConfirmacion(false)
        }
    }, [onConfirmationClose, confirmacion])

    //Manejo los años para saber si están o no mostrandose
    const handleMostrar = (id) => {
        if (isAnioOpen.includes(id)) {
            //Solo guardo todas las id que no sean la que acaba de cambiar de estado
            setIsAnioOpen(isAnioOpen.filter(a => a !== id))
        } else {
            //Guardo lo mismo más el id que acaba de cambiar de estado
            setIsAnioOpen([...isAnioOpen, id])
        }
    }

    const handleMostrarTodo = () => {
        // Si ya hay algo abierto, cerramos todo (vaciamos el array)
        if (isAnioOpen.length > 0) {
            setIsAnioOpen([]);
        } else {
            // IMPORTANTE: Creamos un nuevo array con todos los años de una
            // Usamos .map() para extraer solo los identificadores o el objeto año
            const todosLosAnios = anios.map(anio => anio);
            setIsAnioOpen(todosLosAnios);
        }
    };

    return (
        <div className='pb-50'>
            {/* Modal para confirmar reset */}
            <Modal
                isOpen={isResetOpen}
                onOpenChange={onResetOpenChange}
                backdrop="blur"
                placement="center"
            >
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1 text-danger">
                                <div className="flex items-center gap-2">
                                    <i className="fa-solid fa-triangle-exclamation"></i>
                                    Confirmar Acción
                                </div>
                            </ModalHeader>
                            <ModalBody>
                                <p className="text-default-600">
                                    ¿Estás seguro de que quieres <b>reestablecer todo tu progreso</b>?
                                </p>
                                <p className="text-sm text-foreground/80 italic">
                                    Esta acción volverá todas las materias a su estado inicial (Disponible/Bloqueado) y no se puede deshacer.
                                </p>
                            </ModalBody>
                            <ModalFooter>
                                <Button variant="light" onPress={onResetClose}>
                                    Cancelar
                                </Button>
                                <Button
                                    color="danger"
                                    className="font-bold"
                                    onPress={reestablecerProgreso}
                                >
                                    Reestablecer
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>

            {/* Sección de botones */}
            <div className="grid grid-cols-2 sm:flex sm:justify-between mb-8 gap-2">
                {/* Botón de Reestablecer */}
                <div id="wrapper-btn-reset-progreso" className="flex flex-col">
                    <Button
                        size="sm"
                        variant="flat"
                        color="danger"
                        className="font-bold rounded-xl animate-in fade-in zoom-in duration-300 w-full"
                        startContent={<i className="fa-solid fa-trash-can"></i>}
                        onPress={() => handleBorrado()}
                    >
                        Reestablecer
                    </Button>
                </div>

                <Button
                    size='sm'
                    variant="flat"
                    color="success"
                    className="font-bold rounded-xl animate-in fade-in zoom-in duration-300 text-success-800"
                    onPress={() => navigate("/simulador")}
                >Simular Avance</Button>

                <div id="wrapper-btn-mostrar-todos" className="flex flex-col">
                    <Button
                        size='sm'
                        variant="flat"
                        color="warning"
                        className="font-bold rounded-xl animate-in fade-in zoom-in duration-300 text-warning-800 w-full"
                        onPress={() => handleMostrarTodo()}
                    >
                        {isAnioOpen.length > 0 ? "Mostrar todos" : "Ocultar todos"}
                    </Button>
                </div>

                {/* Selector de Vista (Lista vs Cuadrícula) */}
                <div id="wrapper-view-selector" className="col-span-2 sm:col-span-1 flex justify-center">
                    <Tabs
                        size="sm"
                        variant="bordered"
                        selectedKey={vista}
                        onSelectionChange={setVista}
                        classNames={{
                            tabList: "rounded-xl border-default-200 bg-background/50",
                            cursor: "rounded-lg"
                        }}
                    >
                        <Tab key="grid" title={<div className="flex items-center gap-2"><i className="fa-solid fa-table-cells-large"></i><span>Cuadrícula</span></div>} />
                        <Tab key="list" title={<div className="flex items-center gap-2"><i className="fa-solid fa-list-ul"></i><span>Lista</span></div>} />
                    </Tabs>
                </div>
            </div>
            {/* Sección materias */}
            <div id="tabs-filtro-anio" className="relative">
                <Tabs aria-label="Filtos por año" items={tabs} className=' w-full mask-[linear-gradient(to_right,black_85%,transparent_100%)] pl-[3%] md:mask-none'>
                    {(item) => (
                        <Tab key={item.id} title={item.label} className=''>
                            <div className="space-y-12 ">
                                {item.content.map((valor) => {
                                    let materiasParaMostrar
                                    //Si el valor es taller
                                    if (valor === "taller") {
                                        materiasParaMostrar = talleres
                                    } else {
                                        // Me quedo con las materias de este año
                                        materiasParaMostrar = materias.filter((m) => Number(m.anio) === valor)
                                    }

                                    // Si no hay materias en este año, podríamos evitar renderizarlo (opcional)
                                    if (materiasParaMostrar.length === 0) return null

                                    return (
                                        <section key={valor} className={`flex flex-col gap-6`}>
                                            {/* Cabecera del Año */}
                                            <div className="flex justify-between ">
                                                <div className='flex items-center gap-3 border-b border-default-200 pb-2'>
                                                    <div className="w-1.5 h-8 bg-primary rounded-full shadow-sm"></div>
                                                    <h2 className="text-2xl font-bold text-foreground tracking-tight">
                                                        {valor === "taller" ? "Talleres" : `${valor}° Año`}
                                                    </h2>
                                                </div>
                                                <Button onPress={() => handleMostrar(valor)}>{isAnioOpen.includes(valor) ? "Mostrar más" : "Mostrar menos"}</Button>
                                            </div>

                                            {/* Contenedor de Cuatrimestres */}
                                            <div className={`flex flex-col gap-8 pl-2 sm:pl-4 ${isAnioOpen.includes(valor) ? " hidden" : ""}`}>
                                                {[1, 2].map((cuatri) => {
                                                    // Me quedo con las materias de este cuatrimestre
                                                    const materiasCuatri = materiasParaMostrar.filter(
                                                        (m) => (Number(m.cuatrimestre) % 2 === 0 ? 2 : 1) === cuatri
                                                    )

                                                    if (materiasCuatri.length === 0) return null

                                                    return (
                                                        <div key={cuatri} className="flex flex-col gap-4">
                                                            {/* Cabecera del Cuatrimestre */}
                                                            <div className="flex items-center justify-between bg-default-50 border border-default-200 rounded-lg px-4 py-3 shadow-sm">
                                                                <div className="flex items-center gap-3">
                                                                    <div className="w-1 h-5 bg-default-400 rounded-full"></div>
                                                                    <h3 className="text-lg font-semibold text-default-700">
                                                                        {cuatri}° Cuatrimestre
                                                                    </h3>
                                                                </div>
                                                                <Chip size="sm" variant="flat" className="bg-background border border-default-200 text-default-600 font-medium shadow-sm">
                                                                    {materiasCuatri.length} {materiasCuatri.length === 1 ? 'Materia' : 'Materias'}
                                                                </Chip>
                                                            </div>

                                                            <div className={vista === 'grid'
                                                                ? "grid grid-cols-1 min-[768px]:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5"
                                                                : "flex flex-col gap-3"
                                                            }>
                                                                {materiasCuatri.map((materia, index) => {
                                                                    const esElPrimero = materia.codigo === materias[0]?.codigo;
                                                                    return (
                                                                        <div key={materia.codigo !== "N/A" ? materia.codigo : `${materia.codigo}-${index}`} id={esElPrimero ? 'materia-card-ejemplo' : undefined}>
                                                                            <MateriaCard
                                                                                materia={materia}
                                                                                estado={progreso[materia.codigo]}
                                                                                detalles={progresoDetalles?.[materia.codigo]}
                                                                                actualizarEstados={(target) => handleCambioDeEstado(materia.codigo, target)}
                                                                                abrirInfo={() => abrirInfo(materia)}
                                                                                vista={vista}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </section>
                                    )
                                })}
                            </div>
                        </Tab>
                    )}
                </Tabs>
            </div>


            {/* Drawer de info de las materiasd */}
            <DetalleMateriaModal
                isOpen={isDetailOpen}
                infoMateria={infoMateria}
                materias={materias}
                progreso={progreso}
                progresoDetalles={progresoDetalles}
                setProgresoDetalles={setProgresoDetalles}
                cambioDeEstado={cambioDeEstado}
                plan={plan}
                onOpenChange={onDetailOpenChange}
            />

            {/* Modal para confirmar el cambio de estado de una materia bloqueada */}
            <ConfirmarCambioModal
                setConfirmacion={setConfirmacion}
                setMostrar={setMostrar}
                isOpen={isConfirmationOpen}
                onOpenChange={onConfirmationOpenChange}
                onClose={onConfirmationClose}
                targetState={targetStateModal}
            />

            {/* Modal de captura de datos por transición */}
            <CapturaTransicionModal
                isOpen={isCapturaOpen}
                onOpenChange={onCapturaOpenChange}
                tipo={capturaConfig.tipo}
                materia={capturaConfig.materia}
                onConfirm={handleCapturaConfirm}
            />

        </div >
    )
}

export default MateriasList